import { DEMO_OFFERS } from "@/data/demoOffers";

const HOME_ORDER = ["cdg-mia", "cdg-cun", "cdg-bkk", "cdg-hnd", "cdg-gig", "cdg-jfk", "cdg-mex", "cdg-dxb"];

// Demo layer: later swap these for real API calls (flight API / backend).
export const getHomeOffers = () => {
  const home = DEMO_OFFERS.filter((o) => o.home);
  return [...home].sort((a, b) => HOME_ORDER.indexOf(a.id) - HOME_ORDER.indexOf(b.id));
};

export const getOffersFrom = (originCode) =>
  DEMO_OFFERS.filter((o) => o.origin === originCode);

export const getOffer = (id) => DEMO_OFFERS.find((o) => o.id === id) || null;
